import type { FaireProductEntity } from "../../entity_types/product";

export const p_7h3zaq5p6t: FaireProductEntity = {
  token: "p_7h3zaq5p6t",
  type: "product",
  name: "Coffee Is My Therapist Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/ddc13b602bdd9db9d7aabfc871b4fba6581943811b057515022db8a56ee7d107.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d765b1591e1fc6b0443af7835486c65c3996fb2fe15048adb0f3581e9b8697b8.jpeg",
    "https://cdn.faire.com/fastly/d135f3d27ce4ab0f910ed24fcb829dccd545bb8ac2db301c5c405d33120c035f.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/6b486b4088a310cbec990b32f335f95c25b486685752b41c04813348ab8e4c02.jpeg",
    "https://cdn.faire.com/fastly/c0113e29d54fedb36fd48e625285589fbd34e3ffef85bf903e30859a9e127d9c.jpeg",
    "https://cdn.faire.com/fastly/8987b5fa175f553c2924064709eb46631eda086f67428ab4a019213986d21a8d.jpeg",
    "https://cdn.faire.com/fastly/c0f87b507d05f06c3e3f3dff852c2d0d11e743c77d6ccbae005d2d9b4b3e17e0.jpeg"
  ],
  priceDollars: 6.75,
  description: "For anyone whose coping skills come fair-trade, in a mug.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:07.488Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
